import React, { useContext } from "react";
import { LayoutContext, constants } from "./LayoutContext";
import { useConfigData } from "../hooks/useConfigData";
import { generateGoToBookingMapWidgetLinkText } from "../helpers";
import "./BookingMapWidgetLinkGoToSection.css";

export const BookingMapWidgetLinkGoToSection = ({
  frontmatter,
  i18n_prefix,
  i18n_main,
}) => {
  const configData = useConfigData();
  const layoutContext = useContext(LayoutContext);
  const { theme } = layoutContext;

  const text = generateGoToBookingMapWidgetLinkText(
    configData,
    frontmatter,
    i18n_prefix,
    i18n_main
  );
  return (
    <a
      href="#booking-map-widget"
      id="booking-map-widget-go-to-section-link"
      className={`booking-map-widget-go-to-section-link ${
        theme === constants.THEME_LIGHT ? "theme-light" : "theme-dark"
      }`}
      aria-labelledby="booking-map-widget-go-to-section-link"
      aria-description="Go to booking map widget section"
    >
      <div>🏨{text}</div>
    </a>
  );
};
